// extracted by mini-css-extract-plugin
export default {"main":"EntryCard_main__E1JxX","wrapper":"EntryCard_wrapper__IMGz6","title":"EntryCard_title__6NsCF","btn":"EntryCard_btn__KL+yc","icon":"EntryCard_icon__d1dOs"};